<template>
    <aside
        v-show="!isFullScreen"
        class="fixed right-0 z-30 mt-[52px]"
        :class="[!activityMobileExpanded ? 'w-[50px] h-[52px] bg-green-600' : 'w-[360px] h-full']"
    >
        <!-- 閉じている時 -->
        <div
            v-if="!activityMobileExpanded"
            class=""
        >
            <transition name="fade">
                <div
                    v-if="!activityMobileExpanded"
                    class="cursor-pointe mt-2 flex justify-center items-center"
                    :active="route.fullPath === '/'"
                    @click="toggleSidebar"
                >
                    <activity-open-icon
                        class="h-[40px]"
                    />
                </div>
            </transition>
        </div>

        <!-- 開いてる時 -->
        <transition :name="route.name === 'home' ? 'home' : 'fade'">
            <div
                v-if="activityMobileExpanded"
                class="border-l border-gray-300 w-full bg-white h-full absolute left-0 top-0"
            >
                <div
                    class="flex h-[48px] bg-green-600"
                    @click="toggleSidebar"
                >
                    <div class="mt-1.5 ml-2">
                        <activity-close-icon
                            class="h-[44px]"
                            :active="route.fullPath === '/'"
                        />
                    </div>
                    <div class="w-full flex justify-center items-center pr-11 text-center text-white text-lg font-semibold">
                        チーム活動履歴
                    </div>
                </div>
                <div
                    v-if="activities.length > 0"
                    class="overflow-y-scroll scrollbar-thin scrollbar-thumb-rounded scrollbar-track-gray-200 scrollbar-thumb-gray-400 hover:scrollbar-thumb-gray-500 dark:scrollbar-thumb-gray-100"
                    style="height: 100%;"
                >
                    <div
                        v-for="(activity, index) in activities"
                        :key="index"
                        class="py-2 px-4 border-b "
                        :class="[index % 2 === 1 ? 'bg-[#F0F7FF]' : 'bg-white']"
                    >
                        <div class="mb-1.5">
                            {{ activity.title }}
                        </div>
                        <span
                            class="text-sm text-gray-500"
                        >
                            {{ formatDate(activity.created_at) }}
                        </span>
                    </div>
                </div>
                <div v-else>
                    <p class="m-6 border-gray-300 text-gray-500">
                        チーム活動履歴がありません。
                    </p>
                </div>
            </div>
        </transition>
    </aside>
</template>

<script>
import teamAPI from "@/api/team_activity"
import ActivityCloseIcon from '@/assets/img/ActivityCloseIcon'
import ActivityOpenIcon from '@/assets/img/ActivityOpenIcon'
import {computed, ref} from 'vue'
import {useRoute} from 'vue-router'
import {useStore} from 'vuex'

export default {
    name: 'TeamActivity',
    components: {
        ActivityOpenIcon,
        ActivityCloseIcon
    },
    setup () {
        const route = useRoute()
        const sideBarTitle = ref('')
        const store = useStore()
        const isFullScreen = computed(() => store.state.isFullScreen)
        const activityMobileExpanded = computed(() => store.state.activityMobileExpanded)
        const currentRoute = computed(() => {
            return useRoute().name
        })
        const toggleSidebar = () => store.dispatch('activityMobileToggle')

        // 本日の日付取得
        const days = new Date()
        const daysFormats = ref({
            year: days.getFullYear(),
            month: days.getMonth()+1,
            date: days.getDate()
        })

        // TODO: APIの構成がわかり次第修正
        const activities = ref([
        ])


        const getTeamActivity = async()=>{
            const result = await teamAPI.getTeamActivity()
            const tempActivities = []
            activities.value = result.data
        }
        getTeamActivity()

        const  formatDate = (dateString)=> {
            var date = new Date(dateString) // 日付文字列をDateオブジェクトに変換
            var year = date.getFullYear() // 年を取得
            var month = ("0" + (date.getMonth() + 1)).slice(-2) // 月を取得（0埋め）
            var day = ("0" + date.getDate()).slice(-2) // 日を取得（0埋め）
            var formattedDate = year + "/" + month + "/" + day // 形式に変換
            return formattedDate
        }

        return {
            isFullScreen,
            activityMobileExpanded,
            sideBarTitle,
            currentRoute,
            route,
            toggleSidebar,
            activities,
            daysFormats,
            formatDate
        }
    }
}


</script>
